<template>
  <app-board :header="false" class="p-3 mb-3">

    <el-dialog :visible.sync="dialogVisible" title="" top="5vh" width="75%">
      <h5 class="border-bottom mb-3">{{ operationTitle }}</h5>
      <span v-html="operationResult"></span>
    </el-dialog>

    <h5 class="border-bottom mb-3">Server VoIP Clean Operations </h5>
    <el-row class="mb-3">
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-select-field
            :control="control"
            :field_span="16"
            :label_span="24"
            :options="serversList"
            :translateLabel="false"
            :translateLabels="false"
            @amUpdated="serverUpdated"
            field_mark="required"
            label="Server"
            name="server_id"
            rules="required"></dg-select-field>
      </el-col>
    </el-row>

    <div v-if="serverId">
      <el-row :key="index" class="mb-3 ml-3" v-for="(operation, index) in cleanOperations">
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 24 : 24">
          <h5 class="border-bottom mb-3">{{ operation.title }}</h5>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 24 : 24" class="pt-2">
          <span style="font-size: 12px;" v-html="operation.description">
          </span>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6" class="mt-3">
          <el-button :disabled="requestOn" @click="operationHandler(operation.action, operation.title)"
                     icon="el-icon-delete"
                     size="mini" type="warning">{{ operation.title }}
          </el-button>
        </el-col>
      </el-row>
    </div>

  </app-board>
</template>

<script>
import module from './../index.js'
import {mapState, mapActions} from 'vuex'
import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';

export default {
  mixins: [fieldController],
  props: {
    editMode: {
      required: false,
      type: Boolean,
      default: true
    },
  },
  beforeMount() {
    this.getServersDropDownList({valueKey: 'id'}).then((r) => {
      this.serversList = r
    })
  },
  methods: {
    operationHandler(operation, operationTitle) {
      this.operationTitle = operationTitle
      let data = {
        operation: operation,
        server_id: this.serverId
      }
      this.serverCleanOperation({data}).then((response) => {
        this.operationResult = response.data.output
        this.dialogVisible = true
      })
    },
    ...mapActions('network-server-api', {
      listAllowedServerIPSCommand: 'listAllowedServerIPSCommand',
      allowIPCommand: 'allowIPCommand',
      denyIPCommand: 'denyIPCommand',
      serverCleanOperation: 'serverCleanOperation',
    }),
    ...mapActions('network-server-api', {getServersDropDownList: 'getDropDownList'}),
    serverUpdated() {
      this.serverId = this.dataModel.server_id;
    },
  },
  data() {
    return {
      dialogVisible: false,
      operationTitle: null,
      operationResult: null,
      requestOn: false,
      dataModel: {
        serverId: false
      },
      serverId: false,
      control: this,
      serversList: [],
      cleanOperations: [
        {
          title: 'Clean CDR',
          description: 'Remove all Calls Details Records (CDR) from the fusion server.<br>\n' +
              'It can affect calls tests details in the system.',
          action: 'cleanFusionCDR'
        },
        {
          title: 'Clean Broadcasts',
          description: 'Remove all Broadcasts from fusion server<br>' +
              'It can affect calls tests details in the system.',
          action: 'cleanFusionBroadcasts'
        },
        {
          title: 'Clean Server FreeSwitch Logs',
          description: 'Remove FreeSwitch logs from the server.',
          action: 'cleanServerFreeSwitchLogs'
        },
        {
          title: 'Clean Server Logs',
          description: 'Remove Server logs files.',
          action: 'cleanServerLogs'
        }
      ]
    }
  }
}
</script>
